import axios from "axios"
const getAllTags = async function(){
    const baseUrl = process.env.VUE_APP_EXTRANET_BASE_URL;
    if (!baseUrl) {
        console.log("VUE_APP_EXTRANET_BASE_URL is not defined in environment variables.");
        return [];
    }
    try {
        let result= await axios.get(baseUrl+'tags',
        {
            headers:{
                "Content-Type":"application/json",
                "Authorization": "Bearer "+ localStorage.getItem("jwt")
            }
        }
    
    );

    return result.data
    } catch (error) {
        console.error("Error fetching tags:", error);
        return [];
    }
    
}


const getKiosksWithTags = async function(){
    const baseUrl = process.env.VUE_APP_EXTRANET_BASE_URL;
    if (!baseUrl) {
        console.log("VUE_APP_EXTRANET_BASE_URL is not defined in environment variables.");
        return [];
    }
    let result= await axios.get(baseUrl+'kiosksWithTags',
        {
            headers:{
                "Content-Type":"application/json",
                "Authorization": "Bearer "+ localStorage.getItem("jwt")
            }
        }
    
    );

    //console.log("my Result.data getKiosksWithTags", result.data);

    return result.data
}


export {
    getAllTags, 
    getKiosksWithTags
}